module.exports = __webpack_public_path__ + "img/soul-22.41f58842.png";